const now = '2026-08-14T12:00:00.000Z';

const propertySets = {
  house: [
    'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?auto=format&fit=crop&w=1600&q=86',
    'https://images.unsplash.com/photo-1600566753190-17f0baa2a6c3?auto=format&fit=crop&w=1600&q=86',
    'https://images.unsplash.com/photo-1600607687939-ce8a6c25118c?auto=format&fit=crop&w=1600&q=86',
    'https://images.unsplash.com/photo-1600566753086-00f18fb6b3ea?auto=format&fit=crop&w=1600&q=86',
  ],
  apartment: [
    'https://images.unsplash.com/photo-1522708323590-d24dbb6b0267?auto=format&fit=crop&w=1600&q=86',
    'https://images.unsplash.com/photo-1505693416388-ac5ce068fe85?auto=format&fit=crop&w=1600&q=86',
    'https://images.unsplash.com/photo-1560448204-e02f11c3d0e2?auto=format&fit=crop&w=1600&q=86',
    'https://images.unsplash.com/photo-1560185007-c5ca9d2c014d?auto=format&fit=crop&w=1600&q=86',
  ],
  townhouse: [
    'https://images.unsplash.com/photo-1564013799919-ab600027ffc6?auto=format&fit=crop&w=1600&q=86',
    'https://images.unsplash.com/photo-1570129477492-45c003edd2be?auto=format&fit=crop&w=1600&q=86',
    'https://images.unsplash.com/photo-1600047509807-ba8f99d2cdde?auto=format&fit=crop&w=1600&q=86',
    'https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=1600&q=86',
  ],
};

const author = {
  _id: 'local-nido-demo-author',
  name: 'Equipo',
  lastName: 'NIDO Mendoza Demo',
  phone: '+5492615550101',
  allowWhatsapp: true,
  accountType: 'INMOBILIARIA',
  professionalData: { companyName: 'Equipo NIDO Mendoza Demo', phone: '+5492615550101' },
};

const makeDemo = ({ id, title, department, neighborhood, address, lat, lng, images, price, type = 'casa' }) => ({
  _id: id,
  title,
  description: `Propiedad de demostración creada para recorrer la experiencia completa de NIDO en ${neighborhood}. Las fotografías y los datos son ilustrativos; el entorno y sus servicios se muestran para validar cómo se presenta la zona.`,
  price,
  currency: 'USD',
  operation: 'venta',
  type,
  status: 'disponible',
  surfaceCovered: type === 'departamento' ? 96 : 184,
  surfaceTotal: type === 'departamento' ? 108 : 252,
  bedrooms: 3,
  rooms: 5,
  bathrooms: 2,
  garage: true,
  age: 6,
  condition: 'excelente',
  orientation: 'norte',
  province: 'mendoza',
  department,
  neighborhood,
  address,
  location: { lat, lng, geo: { type: 'Point', coordinates: [lng, lat] } },
  mostrarInfoBarrio: true,
  images,
  features: {
    ambientes: ['3 dormitorios', '2 baños', 'living comedor', 'cocina integrada'],
    exteriores: type === 'departamento' ? ['balcon', 'terraza'] : ['jardin', 'patio', 'parrilla'],
    comodidades: ['luminoso', 'calefaccion', 'internet'],
    extras: ['vista_abierta'],
  },
  author,
  isDemo: true,
  isPromoted: false,
  isFeatured: false,
  isEditorialSelection: false,
  reference: `NIDO-LOCAL-${id.split('-').pop().toUpperCase()}`,
  engagement: { favorites: 12, contacts: 4 },
  views: 186,
  createdAt: now,
  updatedAt: now,
});

export const localZoneDemoProperties = {
  'demo-local-sexta': makeDemo({
    id: 'demo-local-sexta',
    title: 'Casa familiar en Sexta Sección',
    department: 'Capital', neighborhood: 'Sexta Sección', address: 'Jorge A. Calle 580',
    lat: -32.8786, lng: -68.8549, images: propertySets.house, price: 248000,
  }),
  'demo-local-primera': makeDemo({
    id: 'demo-local-primera',
    title: 'Departamento luminoso en Primera Sección',
    department: 'Capital', neighborhood: 'Primera Sección', address: 'Av. Las Heras 640',
    lat: -32.8828, lng: -68.8483, images: propertySets.apartment, price: 139000, type: 'departamento',
  }),
  'demo-local-bombal': makeDemo({
    id: 'demo-local-bombal',
    title: 'Casa renovada en Barrio Bombal',
    department: 'Godoy Cruz', neighborhood: 'Bombal', address: 'Roque Sáenz Peña 720',
    lat: -32.9083, lng: -68.8516, images: propertySets.townhouse, price: 286000,
  }),
};

export function getLocalZoneDemo(id) {
  if (typeof window === 'undefined' || !['localhost', '127.0.0.1'].includes(window.location.hostname)) return null;
  return localZoneDemoProperties[String(id)] || null;
}
